import { store } from "../redux";
import { USER_ROLE_ADMIN_ID, USER_ROLE_OPERATOR_ID, USER_ROLE_STAFF_ID } from "./constants";

function getFileDownloadURL(url: string) {
	return fetch(url)
		.then((response) => {
			return response.blob();
		})
		.then((blob) => {
			return URL.createObjectURL(blob);
		});
}

export const downloadFile = (fileBlob: Blob, fileName: string) => {
	const downloadUrl = URL.createObjectURL(fileBlob);
	const downloadLinkElement = document.createElement("a");

	downloadLinkElement.href = downloadUrl;
	downloadLinkElement.download = fileName;

	document.body.appendChild(downloadLinkElement);
	downloadLinkElement.click();

	URL.revokeObjectURL(downloadUrl);
	downloadLinkElement.parentNode?.removeChild(downloadLinkElement);
};

export const downloadImage = async (downloadURL: string, fileName: string) => {
	const downloadLinkElement = document.createElement("a");

	downloadLinkElement.href = downloadURL;
	downloadLinkElement.download = fileName;

	if (downloadURL.startsWith("http")) {
		downloadLinkElement.href = await getFileDownloadURL(downloadURL);
	}

	document.body.appendChild(downloadLinkElement);
	downloadLinkElement.click();

	URL.revokeObjectURL(downloadURL);
	downloadLinkElement.parentNode?.removeChild(downloadLinkElement);
};

export const convertToTitleCase = (text: string): string => {
	if (!text) return "";

	return text
		.toLowerCase()
		.split(" ")
		.map((word) => word.replace(word[0], word[0]?.toUpperCase()))
		.join(" ");
};

export const convertSnakeToTitleCase = (text: string): string => {
	if (!text) return "";

	return text
		.split("_")
		.map((word) => word.replace(word[0], word[0]?.toUpperCase()))
		.join(" ");
};

export const capitaliseString = (text: string): string => {
	if (!text) return "";

	return text
		.split(" ")
		.map((word) => word.replace(word[0], word[0]?.toUpperCase()))
		.join(" ");
};

export const convertToSnakeCase = (text: string): string => {
	if (!text) return "";

	return text.split(" ").join("_");
};

export enum RESTRICTED_ACCESS_E {
	ADD_OWNER,
	EDIT_OWNER,
	UPLOAD_WHITELIST,
	ADD_BLACKLIST,
	EDIT_BLACKLIST,
	UPLOAD_BLACKLIST,
	EDIT_BUILDING_CONFIG,
	USERS_PAGE,
	EDIT_CONFIG_PAGE,
	RESET_DEVICE,
	EDIT_ADMIN,
	CAMERA_CONFIG,
	ADDITIONAL_SETTINGS_PAGE,
	FORCE_SYNC
}

function getNewRestrictedAccess(
	restrictedAccessList: RESTRICTED_ACCESS_E[],
	newAccess: RESTRICTED_ACCESS_E[]
): RESTRICTED_ACCESS_E[] {
	const newUniqueAccess: RESTRICTED_ACCESS_E[] = [];

	for (const accessItem of newAccess) {
		if (!restrictedAccessList.includes(accessItem)) {
			newUniqueAccess.push(accessItem);
		}
	}

	return newUniqueAccess;
}

export const getRestrictedAccessList = (cloudSyncEnabled: boolean): RESTRICTED_ACCESS_E[] => {
	const restrictedAccessList: RESTRICTED_ACCESS_E[] = [];

	if (cloudSyncEnabled) {
		const accessList = [
			RESTRICTED_ACCESS_E.ADD_OWNER,
			RESTRICTED_ACCESS_E.EDIT_OWNER,
			RESTRICTED_ACCESS_E.UPLOAD_WHITELIST,
			RESTRICTED_ACCESS_E.ADD_BLACKLIST,
			RESTRICTED_ACCESS_E.EDIT_BLACKLIST,
			RESTRICTED_ACCESS_E.UPLOAD_BLACKLIST,
			RESTRICTED_ACCESS_E.EDIT_BUILDING_CONFIG
		];

		restrictedAccessList.push(...getNewRestrictedAccess(restrictedAccessList, accessList));
	}

	const userRole = store.getState().auth.user.role;

	let accessList: RESTRICTED_ACCESS_E[] = [];

	switch (userRole) {
		case USER_ROLE_OPERATOR_ID:
			accessList = [
				RESTRICTED_ACCESS_E.ADD_OWNER,
				RESTRICTED_ACCESS_E.EDIT_OWNER,
				RESTRICTED_ACCESS_E.UPLOAD_WHITELIST,
				RESTRICTED_ACCESS_E.ADD_BLACKLIST,
				RESTRICTED_ACCESS_E.EDIT_BLACKLIST,
				RESTRICTED_ACCESS_E.UPLOAD_BLACKLIST,
				RESTRICTED_ACCESS_E.EDIT_BUILDING_CONFIG,
				RESTRICTED_ACCESS_E.USERS_PAGE,
				RESTRICTED_ACCESS_E.EDIT_CONFIG_PAGE,
				RESTRICTED_ACCESS_E.RESET_DEVICE,
				RESTRICTED_ACCESS_E.ADDITIONAL_SETTINGS_PAGE,
				RESTRICTED_ACCESS_E.CAMERA_CONFIG,
				RESTRICTED_ACCESS_E.FORCE_SYNC
			];

			break;

		case USER_ROLE_STAFF_ID:
			accessList = [
				RESTRICTED_ACCESS_E.RESET_DEVICE,
				RESTRICTED_ACCESS_E.EDIT_ADMIN,
				RESTRICTED_ACCESS_E.EDIT_BUILDING_CONFIG,
				RESTRICTED_ACCESS_E.USERS_PAGE,
				RESTRICTED_ACCESS_E.EDIT_CONFIG_PAGE,
				RESTRICTED_ACCESS_E.ADDITIONAL_SETTINGS_PAGE,
				RESTRICTED_ACCESS_E.CAMERA_CONFIG,
				RESTRICTED_ACCESS_E.FORCE_SYNC
			];
			break;

		case USER_ROLE_ADMIN_ID:
			accessList = [];
			break;

		default:
			break;
	}

	restrictedAccessList.push(...getNewRestrictedAccess(restrictedAccessList, accessList));

	return restrictedAccessList;
};
